import React from "react";
import { GALLERY } from "../data/site";

const ROTATES = ["rotate-[-2deg]", "rotate-[1.5deg]", "rotate-[-1deg]", "rotate-[2deg]", "rotate-[-1.5deg]", "rotate-[1deg]"];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-ink text-cream py-24 md:py-32 px-5 md:px-10 lg:px-16 overflow-hidden">
      <div className="grid grid-cols-12 gap-6 mb-16 items-end">
        <div className="col-span-12 md:col-span-8">
          <div className="inline-flex items-center gap-2 bg-hot/10 border border-hot/30 rounded-full px-4 py-2 mb-6">
            <span className="font-body text-xs tracking-widest uppercase text-hot">O espaço</span>
          </div>
          <h2 className="font-display font-extrabold text-5xl md:text-7xl leading-[0.92]">
            por dentro <br/>do <span className="text-lime">estúdio</span>.
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-5 md:gap-6">
        {GALLERY.map((src, i) => {
          const spans = ["md:col-span-8", "md:col-span-4", "md:col-span-4", "md:col-span-8", "md:col-span-6", "md:col-span-6"];
          const aspects = ["aspect-[16/9]", "aspect-[3/4]", "aspect-[3/4]", "aspect-[16/9]", "aspect-[4/3]", "aspect-[4/3]"];
          return (
            <div
              key={i}
              data-testid={`gallery-image-${i}`}
              className={`col-span-12 ${spans[i]} rounded-3xl overflow-hidden border-2 border-white/10 ${ROTATES[i]} hover:rotate-0 hover:scale-[1.02] transition-all duration-500`}
            >
              <img
                src={src}
                alt={`Estúdio ${i + 1}`}
                className={`w-full h-full object-cover ${aspects[i]}`}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
